import React from 'react';
import './LocationMap.css';
import mapImg from '../../assets/map-placeholder.png'; // Use your uploaded map image

const LocationMap = () => {
  return (
    <div className="map-container">
      <img src={mapImg} alt="Property Location Map" className="map-image" />
    </div>
  );
};

export default LocationMap;